// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26ch_","left":"styles_left__1XeEs","desktopActions":"styles_desktopActions__19T4m","title":"styles_title__1Fp_V"};